import { Component, Input } from '@angular/core';
import { QueryState, WorkflowQueryDto } from '@interfaces/queries';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

interface Message {
	timestamp: number;
	user: string;
	text: string;
	state?: QueryState;
}

@Component({
	selector: 'workflow-query-timeline',
	templateUrl: './query-timeline.component.html',
	styleUrls: ['./query-timeline.component.scss'],
})
export class QueryTimelineComponent {
	private readonly query$ = new ReplaySubject<WorkflowQueryDto>(1);
	
	@Input()
	public set query(dto: WorkflowQueryDto){
		this.query$.next(dto);
	}
	
	public messages$: Observable<Message[]>;
	
	constructor() { 
		this.messages$ = this.query$.pipe(
			map(({ thread }) => [
				{
					timestamp: thread.openingTimestamp,
					user: thread.openingUser,
					text: thread.openingMessage,
				},
				...thread.interactions.map<Message>(i => ({
					timestamp: i.timestamp,
					user: i.username,
					text: i.message,
					state: i.state,
				}))
			].reverse())
		);
	}
	
}
